// Copyright (c) 2019 Deere & Company

import PipSearchSearchBox from '../../shared/components/pip-search-box';
import actionCreators from '../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    searchByDropDown: state.pips.searchDropDown,
    searchQueryString: state.pips.searchQueryString
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps
    }
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(PipSearchSearchBox);



// WEBPACK FOOTER //
// ./src/pip/pip-search/components/pip-search-search-box.js